import { useId } from 'react'
import { clsx } from 'clsx'

/** Decorative globe with network arcs and a gold orbit for hero sections. */
export function GlobeArt({ className }: { className?: string }) {
  const id = useId().replace(/:/g, '')
  const cities = [
    [214, 152],
    [262, 128],
    [300, 170],
    [176, 196],
    [330, 214],
    [240, 236],
    [150, 140],
  ] as const
  return (
    <svg viewBox="0 0 480 480" className={clsx('pointer-events-none select-none', className)} aria-hidden>
      <defs>
        <radialGradient id={`${id}-sphere`} cx="42%" cy="34%" r="70%">
          <stop offset="0%" stopColor="#3f78ff" stopOpacity="0.9" />
          <stop offset="45%" stopColor="#14389e" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#050f30" stopOpacity="0.95" />
        </radialGradient>
        <radialGradient id={`${id}-halo`} cx="50%" cy="50%" r="50%">
          <stop offset="70%" stopColor="#3f78ff" stopOpacity="0" />
          <stop offset="86%" stopColor="#5b8cff" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#5b8cff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fbe7b0" stopOpacity="0" />
          <stop offset="45%" stopColor="#e8bd5c" />
          <stop offset="100%" stopColor="#b3832a" stopOpacity="0.2" />
        </linearGradient>
        <clipPath id={`${id}-clip`}>
          <circle cx="240" cy="240" r="170" />
        </clipPath>
      </defs>
      <circle cx="240" cy="240" r="236" fill={`url(#${id}-halo)`} />
      <circle cx="240" cy="240" r="170" fill={`url(#${id}-sphere)`} />
      <g clipPath={`url(#${id}-clip)`} fill="none" stroke="#9db8ff" strokeOpacity="0.22" strokeWidth="1">
        {[40, 85, 125, 160].map((rx) => (
          <ellipse key={rx} cx="240" cy="240" rx={rx} ry="170" />
        ))}
        {[-120, -70, -20, 30, 80, 130].map((dy) => (
          <ellipse key={dy} cx="240" cy={240 + dy} rx="170" ry="26" />
        ))}
      </g>
      <g fill="none" stroke="#f0cb72" strokeOpacity="0.7" strokeWidth="1.2">
        <path d="M214 152 Q240 110 262 128" />
        <path d="M262 128 Q300 130 300 170" />
        <path d="M176 196 Q200 150 214 152" />
        <path d="M300 170 Q330 180 330 214" />
        <path d="M240 236 Q280 200 300 170" />
        <path d="M150 140 Q170 120 214 152" />
      </g>
      {cities.map(([x, y]) => (
        <g key={`${x}-${y}`}>
          <circle cx={x} cy={y} r="7" fill="#f0cb72" fillOpacity="0.18" />
          <circle cx={x} cy={y} r="2.6" fill="#fbe7b0" />
        </g>
      ))}
      <ellipse
        cx="240"
        cy="250"
        rx="232"
        ry="64"
        transform="rotate(-16 240 250)"
        fill="none"
        stroke={`url(#${id}-gold)`}
        strokeWidth="2"
      />
    </svg>
  )
}
